import React from 'react'
import { observer } from 'mobx-react-lite'

import { Box } from '@material-ui/core'

import { OzonPrintPage } from './Ozon/OzonPrintPage'
import { WildberriesPrintPage } from './Wildberries/WildberriesPrintPage'
import { YandexMarketPrintPage } from './YandexMarket/YandexMarketPrintPage'

import { useStore } from '../../hooks/storeHook'
import { useAccountParams } from '../../hooks/routeHooks'

import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'

export const PrintRoute =
  observer(() => {
    const {integration} = useAccountParams()

    const {allowedIntegrations} = useStore()

    if (!allowedIntegrations[integration]) {
      return null
    }

    return (
      <div className="body_wrapper_zero">
        <Box flex={1}>
          {
            integration === IntegrationType.Ozon &&
            <OzonPrintPage/>
          }

          {
            integration === IntegrationType.Wildberries &&
            <WildberriesPrintPage/>
          }

          {
            integration === IntegrationType.YandexMarket &&
            <YandexMarketPrintPage/>
          }
        </Box>
      </div>
    )
  })